// Fire-and-forget referral tracking for Contact Electric sponsor placements
import { api } from '@/lib/api';

export function trackSponsorClick(placement, opts = {}) {
  // Do NOT block the tel: link — fire and forget
  api.post('/sponsor/click', {
    placement,
    trade: opts.trade || null,
    problem_id: opts.problemId || null,
  }).catch(() => {});
}

export function trackSearchClick(engine, opts = {}) {
  api.post('/sponsor/search-click', {
    engine,
    trade: opts.trade || null,
    zip_code: opts.zip || null,
  }).catch(() => {});
}
